import { render, staticRenderFns } from "./FeeMain.vue?vue&type=template&id=90ea3104&scoped=true"
import script from "./FeeMain.vue?vue&type=script&lang=js"
export * from "./FeeMain.vue?vue&type=script&lang=js"
import style0 from "./FeeMain.vue?vue&type=style&index=0&id=90ea3104&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ea3104",
  null
  
)

export default component.exports